import styled from 'styled-components'
import { HeadLine1, BodySmall } from '../../components/typography/styled'


export const Container = styled.div`
  display: flex;
  flex-direction:column;
  width: 100%;
  min-height: 1244px;
  box-sizing: border-box;
  background-color: ${({theme}) => theme.base.white};
`

export const WelcomeRow = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  width: 100%;
  height: 51px;
  padding: 10px 30px;
`

export const HomeContent = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: 1153px;
  padding: 10px 30px 46px;
`

export const HomeBottomGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 30px;
  width: 100%;
  margin-top: 30px;

  @media screen and (max-width: 900px) {
    grid-template-columns: minmax(0, 1fr);
  }
`

export const WelcomeTitle = styled(HeadLine1)`
  display: flex;
  color:${({theme}) => theme.neutral[100]};
`
type ErrorProp = {
  isError?:boolean
}
export const ErrorContainer = styled.div.withConfig({
  shouldForwardProp: (prop) => prop !== 'isError',
})<ErrorProp>`
  display: ${({isError}) => isError ? 'flex' : 'none'};
  width: 100%;
  min-height: 56px;
  background: ${({theme}) => theme.isDark ? theme.errors[100] : '#FFE6E6'};
  border-radius: 14px;
  flex-direction: row;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  padding: 8px 10px;

  @media screen and (max-width: 600px) {
    align-items: stretch;
    flex-direction: column;
    gap: 8px;

    > button {
      align-self: flex-end;
      min-height: 44px;
    }
  }
`

export const ErrorText = styled(BodySmall)`
  font-size: 15px;
  color: ${({theme}) => theme.errors[600]};
`
